import "./App.css";
import React from "react";
import Home from "./componet/home";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import AOS from "aos";
import "aos/dist/aos.css";
import { useEffect } from "react";
import { UAParser } from "ua-parser-js";
AOS.init();

// function getMobileOperatingSystem() {
//   var parser = new UAParser();
//   var result = parser.getResult();

//   if (result.os.name === "Android") {
//     return "Android";
//   } else if (result.os.name === "iOS") {
//     return "iOS";
//   }

//   return "unknown";
// }

function App() {
  // useEffect(() => {
  //   const os = getMobileOperatingSystem();
  //   setTimeout(() => {
  //     if (os === "Android") {
  //       window.location.href =
  //         "https://play.google.com/store/apps/details?id=com.app.pixellab.editor";
  //     } else if (os === "iOS") {
  //       window.location.href =
  //         "https://apps.apple.com/app/id1577960583";
  //     }
  //   }, 2000);
  // }, []);

  return (
    <div className="App">
      <Home />
    </div>
  );
}

export default App;
